<template>
  <Breadcrumbs
      title="GRN Request"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Goods Received Note', path: '/grn' },
      { label: 'Goods Received Note Edit', path: '/edit-grn' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <orderForm/>
    </div>
  </div>
</template>

<script>
import orderForm from './grneditForm.vue'
export default {
  name: 'indexList',
  components: {
    orderForm,
  },
}
</script>
  